/**
 * Reconnect QuickBooks Online from the re-sync screens: the same Intuit sign-in the
 * import wizard and the validation report use (gl-api /qbo/auth/url). The OAuth
 * callback sends the user back to the dashboard because the origin starts with
 * 'dashboard' (see ThirdParty/QuickBookCallback.tsx).
 */
import { CallApi } from '../../saga/callApi';
import { ACCOUNTING_SYSTEM_API_BASE_URL } from '../../resources/constants';

export const QBO_RECONNECT_REQUIRED = 'qb_sync.qbo_reconnect_required';
export const RESYNC_RECONNECT_ORIGIN = 'dashboard_resync';

/** True when gl-api says the saved QuickBooks Online connection has to be renewed. */
export const needsQboReconnect = (codeOrMessage?: string | null): boolean =>
    !!codeOrMessage && String(codeOrMessage).includes(QBO_RECONNECT_REQUIRED);

export const startQboReconnect = async (branchId: number, onError: () => void): Promise<void> => {
    try {
        localStorage.setItem('qbo_reconnect_origin', RESYNC_RECONNECT_ORIGIN);
        const resp: any = await CallApi.GET(`${ACCOUNTING_SYSTEM_API_BASE_URL}/api/v1/qbo/auth/url?branch_id=${branchId}`, {}, true);
        const url = resp?.data?.success ? resp.data.data?.auth_url : null;
        if (!url) throw new Error('no auth url');
        window.location.href = url;
    } catch (_e) {
        localStorage.removeItem('qbo_reconnect_origin');
        onError();
    }
};
